import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '@/assets/image/27.png';
const _hoisted_1 = {
  class: "comp_home"
};
const _hoisted_2 = {
  class: "board"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = {
  class: "des"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "reason"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "title"
};
const _hoisted_10 = {
  class: "des"
};
import { ref } from 'vue';
import ContactUs from '@/components/ContactUs.vue';
import { boardList, reasonList } from './home_json.js';
export default {
  __name: 'home',
  emits: ['toPage'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    //跳转
    const toPage = id => {
      emit('toPage', id);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[1] || (_cache[1] = _createStaticVNode("<div class=\"banner\" data-v-40759eac><div class=\"content\" data-v-40759eac><div class=\"title\" data-v-40759eac>信悦臻选商家入驻</div><div class=\"des\" data-v-40759eac>海量用户    轻松入驻    极速开店</div><a target=\"_blank\" href=\"https://admin.xinyuemall.com/index/user/register.html\" class=\"btn\" data-v-40759eac>立即入驻</a></div></div>", 1)), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(boardList), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "box"
        }, [_createElementVNode("img", {
          src: item.img,
          alt: ""
        }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(item.des), 1), _createElementVNode("div", {
          onClick: $event => toPage(item.id),
          class: "btn"
        }, "立即查看", 8, _hoisted_6)]);
      }), 128))]), _createElementVNode("div", _hoisted_7, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "reason_name"
      }, "选择我们的理由", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(reasonList), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "box"
        }, [_createElementVNode("img", {
          src: item.img,
          alt: ""
        }, null, 8, _hoisted_8), _createElementVNode("div", _hoisted_9, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_10, _toDisplayString(item.des), 1)]);
      }), 128))]), _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "er"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      })], -1)), _createVNode(ContactUs)]);
    };
  }
};